import ReservasApiService from '@/services/api/skiandnight/ReservasApiService';
import i18n from '@/i18n';

const { t } = i18n.global;

export async function realizarCheckIn(formulariosInscripcionReservas, toaster, grupoId, instant) {
  try {
    const requests = [];
    for (const formulario of formulariosInscripcionReservas) {
      let error = false;
      if (formulario.checkInPendiente && formulario.checkInEnabled && (!instant || formulario.checkInInstant)) {
        const formDataDocumentacion = formDataDocumentacionValidator(formulario);
        if (formDataDocumentacion === null) {
          error = true;
          console.error('Error al validar los datos de check-in');
        } else {
          requests.push(() => ReservasApiService.postFormularioCheckIn(grupoId, formulario.id, formDataDocumentacion));
        }
      }
      if (
        formulario.datosPersonalesPendiente &&
        formulario.datosPersonalesEnabled &&
        (!instant || formulario.datosPersonalesInstant)
      ) {
        const formDataPersonal = formDataPersonalValidator(formulario);
        if (formDataPersonal === null) {
          error = true;
          console.error('Error al validar los datos personales');
        } else {
          requests.push(() =>
            ReservasApiService.postFormularioDatosPersonales(grupoId, formulario.id, formDataPersonal)
          );
        }
      }
      if (formulario.preguntasEnabled && formulario.preguntasPendiente) {
        const formDataPreguntas = formDataPreguntasValidator(formulario);
        if (formDataPreguntas === null) {
          error = true;
          console.error('Error al validar las preguntas');
        } else {
          requests.push(() => ReservasApiService.postFormularioPreguntas(grupoId, formulario.id, formDataPreguntas));
        }
      }
      if (error) {
        toaster.error(t('reserva.checkIn.msg.required'));
        return false;
      }
    }
    await Promise.all(requests.map(request => request()));
    return true;
  } catch (error) {
    console.error('Error al realizar el check-in o enviar datos personales:', error);
    toaster.error(t('reserva.checkIn.msg.error'));
    return false;
  }
}

function formDataPreguntasValidator(formulariosInscripcionReserva) {
  const formDataPreguntas = formulariosInscripcionReserva.formDataPreguntas;
  if (!formDataPreguntas.preguntas.every(pregunta => pregunta.respuesta !== null)) {
    return null;
  }
  return formDataPreguntas;
}

function formDataDocumentacionValidator(formulariosInscripcionReserva) {
  const formDataDocumentacion = formulariosInscripcionReserva.formDataDocumentacion;
  const checkIn = formulariosInscripcionReserva.checkIn;
  if (
    (checkIn.nacionalidadEnabled && !formDataDocumentacion.nacionalidad) ||
    (checkIn.fechaNacimientoEnabled && !formDataDocumentacion.fechaNacimiento) ||
    (checkIn.lugarNacimientoEnabled && !formDataDocumentacion.lugarNacimiento) ||
    (checkIn.tipoDocumentoEnabled && !formDataDocumentacion.tipoDocumento) ||
    (checkIn.dniEnabled && !formDataDocumentacion.dni) ||
    (checkIn.numSoporteEnabled && !formDataDocumentacion.numSoporte) ||
    (checkIn.fechaCaducidadEnabled && !formDataDocumentacion.fechaCaducidadDni) ||
    (checkIn.fechaExpedicionEnabled && !formDataDocumentacion.fechaExpedicionDni) ||
    (checkIn.paisEnabled && !formDataDocumentacion.pais) ||
    (checkIn.provinciaEnabled && !formDataDocumentacion.provincia) ||
    (checkIn.poblacionEnabled && !formDataDocumentacion.poblacion) ||
    (checkIn.domicilioEnabled && !formDataDocumentacion.direccion) ||
    (checkIn.codPostalEnabled && !formDataDocumentacion.codigoPostal) ||
    (checkIn.sexoEnabled && !formDataDocumentacion.sexo) ||
    (checkIn.llegadaEnabled && !formDataDocumentacion.horaCheckIn) ||
    (checkIn.salidaEnabled && !formDataDocumentacion.horaCheckOut) ||
    (checkIn.anversoDniEnabled && !formDataDocumentacion.anversoDni && !formulariosInscripcionReserva.dniSubido) ||
    (checkIn.reversoDniEnabled && !formDataDocumentacion.reversoDni && !formulariosInscripcionReserva.dniSubido)
  ) {
    return null;
  }

  const formData = new FormData();
  if (checkIn.nacionalidadEnabled) {
    formData.append('nacionalidad', formDataDocumentacion.nacionalidad);
  }
  if (checkIn.fechaNacimientoEnabled) {
    formData.append('fechaNacimiento', formDataDocumentacion.fechaNacimiento);
  }
  if (checkIn.lugarNacimientoEnabled) {
    formData.append('lugarNacimiento', formDataDocumentacion.lugarNacimiento);
  }
  if (checkIn.tipoDocumentoEnabled) {
    formData.append('tipoDocumento', formDataDocumentacion.tipoDocumento);
  }
  if (checkIn.dniEnabled) {
    formData.append('dni', formDataDocumentacion.dni);
  }
  if (checkIn.numSoporteEnabled) {
    formData.append('numSoporte', formDataDocumentacion.numSoporte);
  }
  if (checkIn.fechaCaducidadEnabled) {
    formData.append('fechaCaducidadDni', formDataDocumentacion.fechaCaducidadDni);
  }
  if (checkIn.fechaExpedicionEnabled) {
    formData.append('fechaExpedicionDni', formDataDocumentacion.fechaExpedicionDni);
  }
  if (checkIn.sexoEnabled) {
    formData.append('sexo', formDataDocumentacion.sexo);
  }
  if (checkIn.domicilioEnabled) {
    formData.append('direccion', formDataDocumentacion.direccion);
  }
  if (checkIn.codPostalEnabled) {
    formData.append('codigoPostal', formDataDocumentacion.codigoPostal);
  }
  if (checkIn.paisEnabled) {
    formData.append('pais', formDataDocumentacion.pais);
  }
  if (checkIn.provinciaEnabled) {
    formData.append('provincia', formDataDocumentacion.provincia);
  }
  if (checkIn.poblacionEnabled) {
    formData.append('poblacion', formDataDocumentacion.poblacion);
  }
  if (checkIn.llegadaEnabled) {
    formData.append('horaCheckIn', formDataDocumentacion.horaCheckIn);
  }
  if (checkIn.salidaEnabled) {
    formData.append('horaCheckOut', formDataDocumentacion.horaCheckOut);
  }
  if (checkIn.anversoDniEnabled && formDataDocumentacion.anversoDni) {
    formData.append('anversoDni', formDataDocumentacion.anversoDni);
  }
  if (checkIn.reversoDniEnabled && formDataDocumentacion.reversoDni) {
    formData.append('reversoDni', formDataDocumentacion.reversoDni);
  }
  return formData;
}

function formDataPersonalValidator(formulariosInscripcionReserva) {
  const formDataPersonal = formulariosInscripcionReserva.formDataPersonal;
  const datosPersonales = formulariosInscripcionReserva.datosPersonales;
  if (
    (datosPersonales.alergiasEnabled && !formDataPersonal.alergias) ||
    (datosPersonales.alturaEnabled && !formDataPersonal.altura) ||
    (datosPersonales.pesoEnabled && !formDataPersonal.peso) ||
    (datosPersonales.tallaPieEnabled && !formDataPersonal.tallaPie)
  ) {
    return null;
  }

  return formDataPersonal;
}
